export default __webpack_public_path__ + "static/media/promo-spectrespecs_00.2dc096f4.jpg";